<template>
  <div class="pagination">
    <!--    <router-link :class="{'arrow': true, 'disabled': computedCurrentPage == 1}"-->
    <!--                 :to="{name: routeName, query: query()}">&lt;&lt;</router-link>-->
    <router-link class="arrow"
                 :class="{ 'disabled': computedCurrentPage === 1 }"
                 :to="{ name: routeName, query: query(computedCurrentPage === 1 ? 1 : computedCurrentPage - 1) }">
      <i class="icon icon--pagination-prev"></i>
    </router-link>

    <span class="pages">
      <router-link v-for="page in computedTotalPage"
                   v-if="page >= computedCurrentPage - Math.max(10 - computedCurrentPage, 4) && page <= computedCurrentPage + Math.max(9 - computedCurrentPage, 4)"
                   :key="'pagination' + page"
                   :to="{ name: routeName, query: query(page) }"
                   :class="{ 'now': (page === computedCurrentPage) }">{{ page }}</router-link>
    </span>

    <router-link class="arrow"
                 :class="{ 'disabled': computedTotalPage === computedCurrentPage }"
                 :to="{ name: routeName, query: query(computedTotalPage === computedCurrentPage ? computedTotalPage : computedCurrentPage + 1) }">
      <i class="icon icon--pagination-next"></i>
    </router-link>
    <!--    <router-link :class="{'arrow': true, 'disabled': computedTotalPage == computedCurrentPage}"-->
    <!--                 :to="{name: routeName, query: query(computedTotalPage)}">&gt;&gt;</router-link>-->
    &nbsp;&nbsp;&nbsp;&nbsp;
    <span class="total">
      {{ computedCurrentPage }} / {{ computedTotalPage }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: ['totalPage', 'currentPage', 'routeName'],
  computed: {
    computedTotalPage () {
      return Number(this.totalPage || 1)
    },
    computedCurrentPage () {
      return Number(this.currentPage || 1)
    },
    queryWithoutPage () {
      let query = { ...this.$route.query }
      if (query.page) {
        delete query.page
      }
      return query
    }
  },
  methods: {
    query (page = null) {
      let query = { ...this.queryWithoutPage }
      if (page) {
        query.page = page
      }
      return query
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  margin: 25px 22px;

  a {
    display: inline-block;
    vertical-align: middle;
    font-weight: 600;
    color: #444444;
    margin: 0 12px;
    transition: opacity 0.3s ease;

    &.arrow {
      margin: 0;
    }

    &.disabled {
      opacity: 0.35;
      cursor: default;
    }

    &.now {
      color: #ec0047;
    }
  }

  .total {
    display: inline-block;
    vertical-align: middle;
    font-size: 13px;
    font-weight: 400;
    color: #444444;
    margin-top: 2px;
    margin-left: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/pagination.vue